export const extractAndFormatNumber = (input: string) => {
  if (!input) return '';

  const regex = /\d+/;
  const match = input.match(regex);

  if (match) {
    return match[0];
  }

  return '';
};
